<template>
  <b-container>
    <b-card>
      
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form name="form" @submit.prevent="handleSubmit(handleLogin)">
          <validation-provider
            name="User Name"
            :rules="{ required: true, min: 3 }"
            v-slot="validationContext"
          >
            <b-form-group id="input-group" label="Username" label-for="user-name-input">
              <b-form-input
                v-model="username"
                type="text"
                class="form-control"
                name="user-name-input"
                id="user-name-input"
                autocomplete="username"
                :state="getValidationState(validationContext)"
                aria-describedby="input-1-live-feedback"
              />
              <b-form-invalid-feedback id="input-1-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            name="Resource Name"
            :rules="{ required: true }"
            v-slot="validationContext"
          >
            <b-form-group id="input-group" label="Password" label-for="password-input">
              <b-form-input
                v-model="password"
                type="password"
                class="form-control"
                name="password-input"
                id="password-input"
                autocomplete="current-password"
                :state="getValidationState(validationContext)"
                aria-describedby="input-2-live-feedback"
              />
              <b-form-invalid-feedback id="input-2-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-block" :disabled="loading">
              <span v-show="loading" class="spinner-border spinner-border-sm"></span>
              <span>Login</span>
            </button>
          </div>
          <div class="form-group">
            <div v-if="message" class="alert alert-danger" role="alert">{{message}}</div>
          </div>
        </b-form>
      </validation-observer>
    </b-card>
  </b-container>
</template>

<script>
export default {
  name: "Login",

  data: function () {
    return {
      username: "",
      password: "",
      loading: false,
      message: "",
    };
  },

  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },

  created: function () {
    if (this.isLoggedIn) {
      this.$router.push("/ChooseApp");
    }
  },

  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },

    async handleLogin() {
      this.loading = true;

      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.$bvToast.toast(
          `Validation error. Fix the error before submission`,
          {
            title: "Error detected",
            variant: "warning",
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
          }
        );
        return;
      }

      let username = this.username;
      let password = this.password;

      this.$store
        .dispatch("login", { username, password })
        .then(() => {
          this.$router.push("/ChooseApp");
        })
        .catch((error) => {
          this.loading = false;
          this.message =
            (error.response && error.response.data) ||
            error.message ||
            error.toString();
        });
    },
  },
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
}

.card-container.card {
  max-width: 350px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>